import { AfterViewInit, Component, input, Input } from '@angular/core';

@Component({
    selector: 'starfire-image',
    template: '<img [src]="fullPath"/>',
    standalone: false
})
export class StarfireImageComponent implements AfterViewInit {
  name = input.required<string>();
  folder = input<string>();
  fullPath!: string;

  constructor () { };

  ngAfterViewInit () {
    setTimeout(() => {
      let name = this.name().replace(/\s/g, '_').toLowerCase();
      this.fullPath = "../../../assets/set_high-res/" + (this.folder() ? this.folder() + '/' : "") + name + ".png";
    });
  };

}
